import React, { useState, useEffect } from 'react'
import { TextField } from '@mui/material'
import { useField, useFormikContext } from 'formik'
import _ from 'lodash'

const TextfieldWrapper = ({
  name,
  variant = 'outlined',
  InputProps,
  icon_,
  chip,
  ...rest
}) => {
  const [field, meta] = useField(name)
  const [valueForInput, setvalueForInput] = useState(false)
  const { setFieldValue } = useFormikContext()
  const isLnglat = ['longX', 'latY']

  const handleOnChange = event => {
    const { value } = event.target
    if (_.includes(isLnglat, name)) setvalueForInput(true)
    setFieldValue(name, value)
  }

  let configTextfield = {
    ...field,
    ...rest,
    InputProps: {
      ...InputProps,
      ...icon_,
    },
    variant,
  }

  if (meta && meta.touched && meta.error) {
    configTextfield.error = true
    configTextfield.helperText = meta.error
  }

  if (_.includes(isLnglat, name)) {
    configTextfield = {
      ...configTextfield,
      onChange: handleOnChange,
      value: valueForInput ? field.value : rest.initvalue,
    }
  }

  useEffect(() => {
    if (!_.includes(isLnglat, name)) return
    setvalueForInput(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rest.initvalue])

  return (
    <TextField
      {...configTextfield}
      sx={{
        '& .MuiInputBase-input': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      }}
      fullWidth
    />
  )
}

export default React.memo(TextfieldWrapper)
